export const VendorRequestsColumnId = {
  REQUEST_TYPE: 'requestType',
  VENDOR_NAME: 'vendorName',
  STATUS: 'status',
  ITEM_COUNT: 'itemCount',
  LATEST_ACTIVITY: 'latestActivity',
  CREATED_AT: 'createdAt',
  INITIATED_BY: 'initiatedBy',
};

export const DATE_COLUMN_WIDTH = 180;
export const NARROW_COLUMN_WIDTH = 130;

export const EMPTY_MESSAGE_TEXT = 'No vendor requests logged for this loan yet.';
export const NO_FILTER_MATCH_MESSAGE_TEXT = 'No vendor requests match the current filters.';
